// extracted by mini-css-extract-plugin
export default {"wrapper":"lclgi","label":"pEk98","errorMessage":"ay93Y","root":"rWlxR","error":"shRrs"};